export default __webpack_public_path__ + "static/media/goddess-mahalakshmi.e178c9e7.jpg";